export { GetAddressDeviceActionFactory } from "@internal/app-binder/device-action/GetAddressDeviceActionFactory";
